import React from 'react';
import { Check, X } from 'lucide-react';
import { getPasswordChecks, getPasswordStrength } from '../../utils/passwordValidation';

interface PasswordStrengthIndicatorProps {
  password: string;
}

export function PasswordStrengthIndicator({ password }: PasswordStrengthIndicatorProps) {
  const checks = getPasswordChecks(password);
  const strength = getPasswordStrength(password);

  return (
    <div className="mt-2 space-y-2">
      {/* Strength bar - only show when password has been entered */}
      {password && (
        <div className="flex items-center gap-2">
          <div className="flex-1 flex gap-1">
            {[1, 2, 3, 4, 5].map((i) => (
              <div
                key={i}
                className={`h-1.5 flex-1 rounded-full transition-colors ${
                  i <= strength.score ? strength.color : 'bg-gray-200'
                }`}
              />
            ))}
          </div>
          <span className={`text-xs font-semibold ${
            strength.score <= 2 ? 'text-red-600' :
            strength.score <= 3 ? 'text-orange-600' :
            strength.score <= 4 ? 'text-yellow-600' :
            'text-green-600'
          }`}>
            {strength.label}
          </span>
        </div>
      )}

      {/* Requirements checklist - always visible */}
      <div className="space-y-1">
        {checks.map((check, idx) => (
          <div key={idx} className="flex items-center gap-1.5">
            {check.met ? (
              <Check className="w-3 h-3 text-green-500" />
            ) : (
              <X className="w-3 h-3 text-gray-300" />
            )}
            <span className={`text-xs ${check.met ? 'text-green-600' : 'text-gray-400'}`}>
              {check.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
